import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PellowahPage from "../pages/services/pellowah/page";
import UmanaPage from "../pages/services/umana/page";
import BachPage from "../pages/services/bach/page";
import QuantumPage from "../pages/services/quantum/page";
import OraclePage from "../pages/services/oracle/page";
import ChakraPage from "../pages/services/chakra/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/pellowah",
    element: <PellowahPage />,
  },
  {
    path: "/services/umana",
    element: <UmanaPage />,
  },
  {
    path: "/services/bach",
    element: <BachPage />,
  },
  {
    path: "/services/quantum",
    element: <QuantumPage />,
  },
  {
    path: "/services/oracle",
    element: <OraclePage />,
  },
  {
    path: "/services/chakra",
    element: <ChakraPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;